import React from 'react';
import { Grid } from '@mui/material';
import Avatar from '../../../../../../components/Avatar';
import { hasImage } from '../../../../../../utils';

const ReporterSection = ({ reporterData }) => {
  const reporterName = `${reporterData?.first_name || ''} ${reporterData?.last_name || ''}`;
  const reporterInitials = `${reporterData?.first_name?.[0] || ''}${reporterData?.last_name?.[0] || ''}`;

  return (
    <div className="box">
      <Grid item className="allocated-hours">
        <p>Reporter</p>
        <div className="reporter-detail taskdetail-sidebar-right-col">
          <div className="reporter-image">
            <Avatar
              title={reporterName}
              className="header-avatar add-comment-avtar"
              user_image={reporterData?.user_image}
              style={
                !hasImage(reporterData?.user_image) && {
                  bgcolor: reporterData?.profile_color?.background,
                  color: reporterData?.profile_color?.text,
                }
              }
            >
              {reporterInitials}
            </Avatar>
          </div>
          <div className="reporter-name">
            {reporterData ? (
              <p>{reporterName}</p>
            ) : (
              <p>None</p>
            )}
          </div>
        </div>
      </Grid>
    </div>
  );
};

export default React.memo(ReporterSection);